import { useQuery } from '@tanstack/react-query';
import {
  getSectorInsightsList,
  getSectorInsightsSources,
  getSectorInsightsStocks,
} from './api';
import type {
  SectorInsightsListResponse,
  SectorInsightsSourcesResponse,
  SectorInsightsStocksResponse,
} from './types';

const QK_LIST = 'sector-insights-list';
const QK_STOCKS = 'sector-insights-stocks';
const QK_SOURCES = 'sector-insights-sources';

// 표준: 폴링 300s (사용자 명세).
const POLL_MS = 300_000;

export function useSectorInsightsList(q?: string) {
  const normalized = q?.trim() || '';
  return useQuery<SectorInsightsListResponse>({
    queryKey: [QK_LIST, normalized],
    queryFn: () => getSectorInsightsList(normalized || undefined),
    staleTime: POLL_MS,
    refetchInterval: POLL_MS,
  });
}

export function useSectorInsightsStocks(
  canonicalKey: string | null,
  page: number,
  size: number
) {
  return useQuery<SectorInsightsStocksResponse>({
    queryKey: [QK_STOCKS, canonicalKey, page, size],
    queryFn: () => getSectorInsightsStocks(canonicalKey as string, page, size),
    enabled: !!canonicalKey,
    staleTime: POLL_MS,
    refetchInterval: POLL_MS,
  });
}

export function useSectorInsightsSources(canonicalKey: string | null) {
  return useQuery<SectorInsightsSourcesResponse>({
    queryKey: [QK_SOURCES, canonicalKey],
    queryFn: () => getSectorInsightsSources(canonicalKey as string),
    enabled: !!canonicalKey,
    staleTime: POLL_MS,
    refetchInterval: POLL_MS,
  });
}
